module.exports = __webpack_public_path__ + "static/media/heinrichsdoerferweg_garten.6651fff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/projekte/heinrichsdoerferweg_garten.jpg
// module id = 356
// module chunks = 0